import React from "react";
import { LetterOfAuthorization, Header, Image, Subheader, InstructionList,InstructionSubList, ContributionSubList, OwnerAuthority, FontMediumText, SignGurantee, FormInput, AuthorizedOffice, Guildelines, Print, CharityACDetails, LetterWrapper,FontBoldText } from "./styles";
import logo from '../../../../../../../../assets/icons/vcep-logo.png';
import printIcon from "../../../../../../../../assets/icons/print.svg";
import PrintComponents from "react-print-components";
import { StyleLessButton } from "../../../../../../../../CommonComponents/commonStyles";
import { IconPadding,DataExportPrint } from "../../../../styles";
import { removeHeaderFooter } from "../../../../utils";
let stockCert = [];
export class ViewContribution extends React.Component {

    componentDidMount = () => {
        removeHeaderFooter();
    }

    renderPrintData = () => {
        return (
<LetterOfAuthorization>
                <Image justifyContent = "start" marginBottom="10px">
                    <img src={logo} alt="vanguard"></img>
                </Image>
                <Header>Letter of authorization</Header>
                <Subheader>Contribution by stock certificate
                </Subheader>
                <InstructionList>
                    <li>
                        Vanguard Charitable account information
                        <div>Account number: { stockCert.logAcNum }</div>
                        <div>Account name: { stockCert.logAcName }</div>
                    </li>
                    <li>
                        Funding instructions
                        <InstructionSubList type="A">
                            <li>
                                Verify pre-populated information and complete any additional information. Print out your
                                completed <i>Letter of authorization </i>and have it signed by all registered owners of the assets being
                                donated. A separate <i>Letter of authorization </i>must be completed for each certificate with differing
                                registrations.
                            </li>
                            <li>
                                Mail this form along with your endorsed certificate(s) in one envelope the address below. To
                                prevent loss, send the materials by registered, certified, or overnight mail with return receipt
                                requested to:
                                <CharityACDetails marginLeft="50px">
                                    <FontMediumText>Vanguard Charitable</FontMediumText>
                                    <FontMediumText>2670 Warwick Avenue</FontMediumText>
                                    <FontMediumText>Warwick, RI 02889-9509</FontMediumText>
                                </CharityACDetails>
                            </li>
                            
                        </InstructionSubList>
                    </li>
                    <li>
                        Transfer-of-ownership instructions
                        <ContributionSubList type="A">
                            <li>To the transfer agent or broker:
                                <span> Please accept this letter as the authorization to irrevocably
                                    transfer ownership of the assets specified below to Vanguard Charitable. <FontBoldText>Securities should be
                                    transferred in-kind and are not to be liquidated.</FontBoldText>
                                </span>
                                <div className="mt-05">Contribution <FontBoldText>to</FontBoldText> Vanguard Charitable brokerage account number: 74703205</div>
                            </li>
                            <li>Security certificate details
                                <div>
                                    Both this <i>Letter of authorization</i> and stock certificate(s) require Medallion signature guarantees.
                                </div>
                                <div className="mt-05">Security name: {stockCert.fundName}</div>
                                <div>Security ticker : {stockCert.ticker}</div>
                                <div>Number of shares: {stockCert.shares ? stockCert.shares : (stockCert.allShares ? 'All Shares' : stockCert.shares)}</div>   
                            </li>
                        </ContributionSubList>
                    </li>
                    <li>
                        Signatures: This section must be signed by all registered owners of the assets to be donated.
                        <div className="mt=05">I/We hereby irrevocably relinquish all rights, title and interest to the assets specified in Section 3 of this
                            document. I/We hereby acknowledge that I/we have read and understand the terms of the transfer of
                            assets I/we have requested and further acknowledge that the terms of this transfer are binding regardless
                            of any other agreement I/we have with Vanguard Charitable.
                        </div>
                        <div className="mt-10">
                            <FontBoldText>Signature(s)</FontBoldText> Do not sign until you are in the presence of the person guaranteeing your signature.
                        </div>
                        <OwnerAuthority>
                        <div>Owner A</div>
                        <div>Owner's Name: {(stockCert.type === "Individual" || stockCert.type === "Joint") ? stockCert.name : stockCert.donorName}</div>
                        {/* <div>Owner middle initial:</div>
                        <div>Owner last name: Shanod</div> */}
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    { stockCert.type === "Joint" ?
                    <OwnerAuthority>
                        <div>Owner B</div>
                        <div>Owner's Name: {stockCert.firstName + ' ' +  stockCert.lastName}</div>
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    :
                    ''
                    }
                    &nbsp;
                        <div>
                            <i>This form requires a Medallion signature guarantee, which can be obtained from a bank or broker - not
                                a notary. Please ensure with your bank, broker, or other financial institution that the signature
                                guarantee(s) provided will cover the amount of the contribution.</i>
                        </div>
                        <SignGurantee>
                            <FontBoldText>Medallion signature guarantee - REQUIRED</FontBoldText>
                            <div>A notary public cannot provide a signature guarantee.</div>
                            <FormInput>
                                <label>Signature of authorized officer:</label>
                                <input type="text"></input>
                            </FormInput>
                            <FormInput>
                                <label>Name of institution:</label>
                                <input type="text"></input>
                            </FormInput>
                            <FormInput>
                                <label>Title:</label>
                                <input type="text"></input>
                            </FormInput>
                            <FormInput>
                                <label>Date:</label>
                                <input type="text"></input>
                            </FormInput>
                            <AuthorizedOffice>
                                <div>
                                    Authorized officer to place stamp here.
                                </div>
                                <div>
                                    This applies to all signatures in Section 4.
                                </div> 
                            </AuthorizedOffice>
                        </SignGurantee>
                    </li>
                    <li>Return information
                        <div>
                            Return this completed form and certificate(s) by mail to:
                        </div>
                        <CharityACDetails marginLeft="20px">
                            <FontMediumText>Vanguard Charitable</FontMediumText>
                            <FontMediumText>2670 Warwick Avenue</FontMediumText>
                            <FontMediumText>Warwick, RI 02889-9509</FontMediumText>
                        </CharityACDetails>
                    </li>
                </InstructionList>
                <Guildelines>
                    If applicable, Vanguard Charitable will send a tax substantiation letter once the contribution is processed.
                    For more information, view our <a href={stockCert.envURL + "/company-policies/policies-and-guidelines"} target="_blank">
                    <span>Policies and guidelines</span></a> booklet.
                </Guildelines>
            </LetterOfAuthorization>  
        )
    }

    render() {
        stockCert = {};
        stockCert = localStorage["stockCert"] ? JSON.parse(localStorage["stockCert"]) : [];
        return (
                     <LetterWrapper> 
                     <PrintComponents
                        className="i_print"
                        trigger={
                          <Print>
                          <StyleLessButton>
                            <IconPadding className="ml2">
                              <img src={printIcon} alt="print"/>
                              <DataExportPrint>PRINT</DataExportPrint>
                            </IconPadding>
                          </StyleLessButton>
                          </Print>
                        } >
                            {this.renderPrintData()}
                        </PrintComponents>
                     {this.renderPrintData()}</LetterWrapper>
            );               
    }
}

export default ViewContribution;